// Import model
import { DataviewProjectAppointmentResponse } from '../models/DataviewProjectAppointmentResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterProjectAppointmentRequest } from '../models/FilterProjectAppointmentRequest';
import { ProjectAppointment } from '../models/ProjectAppointment';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterProjectAppointmentRequestSerializer } from './FilterProjectAppointmentRequestSerializer';
import { ProjectAppointmentSerializer } from './ProjectAppointmentSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewProjectAppointmentResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewProjectAppointmentResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewProjectAppointmentResponse instance
   */
  static deserialize(json: string): DataviewProjectAppointmentResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewProjectAppointmentResponse instance
   */
  static fromObject(obj: any): DataviewProjectAppointmentResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewProjectAppointmentResponse');
    }


    const instance: DataviewProjectAppointmentResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ProjectAppointmentSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterProjectAppointmentRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewProjectAppointmentResponse instances
   */
  static deserializeArray(json: string): DataviewProjectAppointmentResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewProjectAppointmentResponse instance to a JSON string
   */
  static serialize(instance: DataviewProjectAppointmentResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewProjectAppointmentResponse instance to a plain object
   */
  static toObject(instance: DataviewProjectAppointmentResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ProjectAppointmentSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterProjectAppointmentRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewProjectAppointmentResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewProjectAppointmentResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
